import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ProcessStepsLogicService } from './logic/process-steps/process-steps-logic.service';
import { ProcessStepsDaoService } from './dao/process-steps-dao.service';
import { ProcessStepsStorageDaoService } from './dao/process-steps-dao/process-steps-storage-dao.service';
import { ProcessStepsService } from './logic/process-steps.service';

@NgModule({
  declarations: [],
  imports: [CommonModule],
  providers: [
    { provide: ProcessStepsService, useClass: ProcessStepsLogicService },
    {
      provide: ProcessStepsDaoService,
      useClass: ProcessStepsStorageDaoService
    }
  ]
})
export class ProcessStepsModule {}
